import { Locale, type LocalizedString } from "../Locale.js";

export const helpPalletsPathMap = {
	[Locale.cs]: "chci-skladovat-palety" as const,
} satisfies LocalizedString;
